/**
 * Created by fers on 05.02.16.
 */

import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

const messages = defineMessages({
    title: {id: 'billingRuleAdd.title', 'defaultMessage': 'Adding billing rule'}
});

class BillingRuleAdd extends React.Component {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'billingRules';

    constructor(props) {
        super(props);

        this.state = {
            fromChannelId: null,
            toChannelId: null,
            fromEntityId: null,
            toEntityId: null,
        };
    }

    render() {
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={{
                        'flowDef': {
                            values: this.props.user.flowDefs.edges.map(({node}) => node),
                            display: (item) => {
                                return item['name'];
                            },
                        },
                        'flow': {
                            values: this.props.user.organisation.flows.edges.map(({node}) => node),
                            display: (item) => {
                                return item['flowTitle'];
                            },
                        },
                        'billingNote': {},
                        'validSince': {},
                        'validTo': {},
                        'overridePricePerInstance': {},
                        'overridePricePerInstanceNext': {},
                        'overridePricePerInvocation': {},
                        'overrideTablePerInvocation': {},
                        'overrideMinPrice': {},
                    }}
                    extraConfig={[{
                              type: 'RANGE_ADD',
                              parentName: 'organisation',
                              parentID: this.props.user.organisation.id,
                              connectionName: 'billingRules',
                              edgeName: 'edge',
                              rangeBehaviors: {
                                '': 'append',
                              },
                    }]}
                    fatQuery={Relay.QL `fragment on CreateBillingRulePayload @relay(pattern: true) {
                        edge {
                            node {
                                id,
                            }
                        },
                        organisation {
                            billingRules(first: 2000) {
                                edges {
                                    node {
                                        id
                                    }
                                }
                            }
                        }
                    }`}
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createBillingRule }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(BillingRuleAdd), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    flows(first: 2000, deleted: false) {
                        edges {
                            node {
                                id,
                                realId,
                                flowTitle,
                                name,
                            }
                        }
                    }    
                },
                flowDefs(first: 2000) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                        }
                    }
                }
            }
        `,
    },
});
